import { ReactComponent as emoji_happy } from 'assets/img/emojis/happy.svg'
import { ReactComponent as emoji_neutral } from 'assets/img/emojis/neutral.svg'
import { ReactComponent as emoji_unhappy } from 'assets/img/emojis/unhappy.svg'

export const unhappy = emoji_unhappy
export const neutral = emoji_neutral
export const happy = emoji_happy
